import { IPublicClientApplication } from '@azure/msal-browser';
import {
  AuthenticatedTemplate,
  MsalProvider,
  UnauthenticatedTemplate,
  useMsal,
} from '@azure/msal-react';
import { BrowserRouter } from 'react-router';

import { AbilityContextProvider } from './components/common/AbilityContext';
import { ThemeProvider } from './components/common/ThemeProvider/ThemeProvider';
import { ToasterContextProvider } from './components/common/Toaster';
import { Routes } from './pages';
import { LoginPage } from './pages/LoginPage';
import { QueryProvider } from './utils/Api';

interface AppProps {
  instance: IPublicClientApplication;
}

const MainContent = () => {
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();

  return (
    <>
      <AuthenticatedTemplate>
        {activeAccount ? (
          <AbilityContextProvider account={activeAccount}>
            <BrowserRouter>
              <Routes />
            </BrowserRouter>
          </AbilityContextProvider>
        ) : null}
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <LoginPage />
      </UnauthenticatedTemplate>
    </>
  );
};

function App({ instance }: AppProps) {
  return (
    <MsalProvider instance={instance}>
      <ThemeProvider>
        <ToasterContextProvider>
          <QueryProvider>
            <MainContent />
          </QueryProvider>
        </ToasterContextProvider>
      </ThemeProvider>
    </MsalProvider>
  );
}

export default App;
